/**
 * User Manager
 * Manages current user state and user object construction
 */

import { getCurrentUser } from './cognitoClient';
import { decodeToken, parseAttributes } from './tokenManager';

/**
 * Build user object from Cognito response and tokens
 * Formats user data to match Amplify's structure for compatibility
 * @param {Object} cognitoUser - Response from Cognito GetUser
 * @param {Object} tokens - { accessToken, idToken, refreshToken }
 * @returns {Object} Formatted user object
 */
export const buildUserObject = (cognitoUser, tokens) => {
  return {
    username: cognitoUser.Username,
    attributes: parseAttributes(cognitoUser.UserAttributes),
    UserAttributes: cognitoUser.UserAttributes, // Keep original format for compatibility
    signInUserSession: {
      accessToken: {
        jwtToken: tokens.accessToken,
        payload: decodeToken(tokens.accessToken)
      },
      idToken: {
        jwtToken: tokens.idToken,
        payload: decodeToken(tokens.idToken)
      }
    }
  };
};

/**
 * Fetch and build current user from access token
 * @param {string} accessToken
 * @param {Object} tokens - Full token set
 * @returns {Promise<Object>} User object
 */
export const fetchUser = async (accessToken, tokens) => {
  const cognitoUser = await getCurrentUser(accessToken);
  return buildUserObject(cognitoUser, tokens);
};
